
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
	import Switch from '@/components/switch.vue';
	import UploadImg from '@/components/upload-img.vue';
  import {
    memberRegistrationConfigsave,
    memberRegistrationConfiginit
  } from "@/api/auth"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
			'slz-switch': Switch,
      UploadImg

    }
  })

  export default class ProductList extends Vue {
    private loading = false
    private form:any = {
      Id:0,
      IsOpenOccupancyRecommendNoQuota:true,
      MemberRegistrationType:[],
      AccrueSpendMoney:'',
      ThroughZoneProductPaySuccessImgUrl:[],
      ThroughZoneAutoApplyAuthProductPaySuccessImgUrl:[],
      ThirdRoleInitialQuota:'',
      SecondRoleInitialQuota:'',
      FirstRoleInitialQuota:'',
      IsOpenThirdRoleProtectRole:false,
      ThirdRoleProtectRoleInstructions:'',
      ThirdRoleProtectRoleCurrentRequire:'',
      ThirdRoleProtectRoleRequireChangeRecord:'',
      NoFreeAuthThirdRoleRestoreRequire:'',
    }


    private mounted () {
      this.getInit()
    }

    private nextMonth(){
      let month = new Date().getMonth()+1
      return month==12?1:(month+1)
    }
    private async getInit(){
      try{
        this.loading = true
        let res = await memberRegistrationConfiginit({})
        if(res.IsSuccess){
          let form = res.Result
          form.ThroughZoneProductPaySuccessImgUrl = [form.ThroughZoneProductPaySuccessImgUrl]
          form.ThroughZoneAutoApplyAuthProductPaySuccessImgUrl = [form.ThroughZoneAutoApplyAuthProductPaySuccessImgUrl]
          form.AccrueSpendMoney = form.AccrueSpendMoney||''
          form.ThirdRoleProtectRoleCurrentRequire = form.ThirdRoleProtectRoleCurrentRequire||''
          form.NoFreeAuthThirdRoleRestoreRequire = form.NoFreeAuthThirdRoleRestoreRequire||''
          this.form = JSON.parse(JSON.stringify(form))
        }
      }finally{
        this.loading = false
      }
    }
    private test(){
      if(this.form.MemberRegistrationType.some(v=>v==2)&&
        (!this.form.AccrueSpendMoney||this.form.AccrueSpendMoney<0.01||this.form.AccrueSpendMoney>1000000)){
        this.$message.error('累计消费金额允许0.01~100万')
        return false
      }
      if(!this.form.ThroughZoneProductPaySuccessImgUrl||!this.form.ThroughZoneProductPaySuccessImgUrl.length){
        this.$message.error('请上传支付页图片')
        return false
      }
      if(!this.form.ThroughZoneAutoApplyAuthProductPaySuccessImgUrl||!this.form.ThroughZoneAutoApplyAuthProductPaySuccessImgUrl.length){
        this.$message.error('请上传自动注册商品后的支付成功页图片')
        return false
      }
      if(this.form.IsOpenThirdRoleProtectRole){
        if(!this.form.ThirdRoleProtectRoleCurrentRequire){
          this.$message.error('请设置保级要求')
          return false
        }
        if(this.form.ThirdRoleProtectRoleCurrentRequire<1||this.form.ThirdRoleProtectRoleCurrentRequire>99999){
          this.$message.error('请填写1~99999的整数')
          return false
        }
        if(!this.form.NoFreeAuthThirdRoleRestoreRequire){
          this.$message.error('请设置恢复授权的方式')
          return false
        }
        if(this.form.NoFreeAuthThirdRoleRestoreRequire<1||this.form.NoFreeAuthThirdRoleRestoreRequire>99999){
          this.$message.error('请填写1~99999的整数')
          return false
        }
      }
      if(this.form.ThirdRoleInitialQuota<0||this.form.ThirdRoleInitialQuota>99999||
        this.form.SecondRoleInitialQuota<0||this.form.SecondRoleInitialQuota>99999||
        this.form.FirstRoleInitialQuota<0||this.form.FirstRoleInitialQuota>99999
      ){
        this.$message.error('额度数量允许0~99999')
        return false
      }
      return true
    }
    private async save(){
      if(!this.test()) return
      try{
        this.loading = true
        let form = JSON.parse(JSON.stringify(this.form))
        form.AccrueSpendMoney = form.MemberRegistrationType.some(v=>v==2)?form.AccrueSpendMoney:''
        form.ThroughZoneProductPaySuccessImgUrl = form.ThroughZoneProductPaySuccessImgUrl[0]
        form.ThroughZoneAutoApplyAuthProductPaySuccessImgUrl = form.ThroughZoneAutoApplyAuthProductPaySuccessImgUrl[0]
        let res = await memberRegistrationConfigsave(form)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.getInit()
        }
      }finally{
        this.loading = false
      }
    }
    private uploadSuc(list,key){
      this.form[key] = list
      // console.log(this.form[key])
    }
  }
